import React from 'react';
import { Helmet } from "react-helmet";
import { Label } from "../sections/Label/Label";
    
const BiorBo = () => {
    return (
        <>
            <Helmet>
                <title>Lembawe9 - Burn it or Burn out</title>
                <meta 
                    name="description" 
                    content="Discover Burn it or Burn out, the innovative record label by Lembawe9, shaping the future of Moroccan rap." 
                />
            </Helmet>
            <main>
              <Label/>
            </main>
        </>
    )
}

export default BiorBo